/**
 * Supabase client — the temporary auth + data backend for Saheeh while we
 * wait on a dedicated Firebase project. Same Supabase project that powers
 * the `blacklayers-pos` test tenant (Frankfurt, project ref
 * `murxacfdulrkqinlubmz`).
 *
 * URL + anon key are intentionally hardcoded here because they're public
 * by design (the anon key only grants access via Postgres RLS — which is
 * configured to scope every read/write to the authenticated user's tenant).
 */

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  'https://murxacfdulrkqinlubmz.supabase.co';

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11cnhhY2ZkdWxya3Fpbmx1Ym16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MDE0NjUsImV4cCI6MjA5NDA3NzQ2NX0.8oPriepwpaq2xs-FYUdTOk9PG5Ry3eVmibYTPvSiw4A';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
